import { Stack } from "@mantine/core";
import { Tenant } from "src/graphql/generated/graphql";

import { InfoWidget } from "./widgets/info";
import { LogoWidget } from "./widgets/logo";
import { StampWidget } from "./widgets/stamp";

export interface OverviewTabProps {
    tenant: Tenant;
    onTenantUpdate?();
}

export const OverviewTab = ({ tenant, onTenantUpdate }: OverviewTabProps) => {
    return (
        <Stack>
            <InfoWidget
                tenant={tenant}
                onTenantUpdate={onTenantUpdate}
            />
            <LogoWidget
                tenant={tenant}
                onTenantUpdate={onTenantUpdate}
            />
            <StampWidget
                tenant={tenant}
            />
        </Stack>
    );
};
